import api from './api';

const complianceService = {
  // Audit logs
  getAuditLogs: (params) => api.get('/audit-logs', { params }),
  getAuditLog: (id) => api.get(`/audit-logs/${id}`),

  // SLA
  getSLAs: (params) => api.get('/sla', { params }),
  getSLA: (id) => api.get(`/sla/${id}`),
  createSLA: (data) => api.post('/sla', data),
  updateSLA: (id, data) => api.put(`/sla/${id}`, data),
  getSLAMetrics: (params) => api.get('/sla/metrics', { params }),

  // Disputes
  getDisputes: (params) => api.get('/disputes', { params }),
  getDispute: (id) => api.get(`/disputes/${id}`),
  createDispute: (data) => api.post('/disputes', data),
  updateDispute: (id, data) => api.put(`/disputes/${id}`, data),
  resolveDispute: (id, resolution) => api.post(`/disputes/${id}/resolve`, resolution),
  escalateDispute: (id) => api.post(`/disputes/${id}/escalate`),
  getDisputeTimeline: (id) => api.get(`/disputes/${id}/timeline`),
  uploadEvidence: (id, formData) =>
    api.post(`/disputes/${id}/evidence`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
};

export default complianceService;
